module.exports = __webpack_public_path__ + "common/icon-app-design-d37d62ebb7a4687550cbb938957d6977.svg";